<template>
    <!-- Best Services -->
    <section class="section best-services">
        <div class="container">
            <div class="section-heading aos" data-aos="fade-up">
                <h2>Extra Benefits, Unmatched <span>Service Excellence</span></h2>
                <p class="sub-title">Advance your badminton journey with DreamSports: Exclusive perks, exceptional service.
                </p>
            </div>
            <div class="row">
                <div class="col-lg-6">
                    <div class="best-service-img aos" data-aos="fade-up">
                        <img src="@/assets/img/best-service.jpg" class="img-fluid" alt="Service">
                        <div class="service-count-blk">
                            <div class="coach-count">
                                <h3>Coaches</h3>
                                <h2><span class="counter-up">88</span>+</h2>
                                <h4>Highly skilled badminton coaches with extensive expertise in the sport.</h4>
                            </div>
                            <div class="coach-count coart-count">
                                <h3>Courts</h3>
                                <h2><span class="counter-up">59</span>+</h2>
                                <h4>Well-maintained courts for optimal badminton experiences.</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="ask-questions aos" data-aos="fade-up">
                        <h3>Frequently Asked Questions</h3>
                        <p>Here are some frequently asked questions about badminton at DreamSports:</p>
                        <div class="faq-info">
                            <div class="accordion" id="accordionExample">

                                <!-- FAQ Item -->
                                <div class="accordion-item">
                                    <h2 class="accordion-header" id="headingOne">
                                        <a href="javascript:;" class="accordion-button" data-bs-toggle="collapse"
                                            data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                            How can I book a badminton court at DreamSports?
                                        </a>
                                    </h2>
                                    <div id="collapseOne" class="accordion-collapse collapse show"
                                        aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                        <div class="accordion-body">
                                            <div class="accordion-content">
                                                <p>Book your DreamSports badminton court online or contact our customer
                                                    service for seamless reservations. </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- /FAQ Item -->

                                <!-- FAQ Item -->
                                <div class="accordion-item">
                                    <h2 class="accordion-header" id="headingTwo">
                                        <a href="javascript:;" class="accordion-button collapsed" data-bs-toggle="collapse"
                                            data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                            What is the duration of a badminton court booking?
                                        </a>
                                    </h2>
                                    <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                                        data-bs-parent="#accordionExample">
                                        <div class="accordion-body">
                                            <div class="accordion-content">
                                                <p>Book your DreamSports badminton court online or contact our customer
                                                    service for seamless reservations. </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- /FAQ Item -->

                                <!-- FAQ Item -->
                                <div class="accordion-item">
                                    <h2 class="accordion-header" id="headingThree">
                                        <a href="javascript:;" class="accordion-button collapsed" data-bs-toggle="collapse"
                                            data-bs-target="#collapseThree" aria-expanded="false"
                                            aria-controls="collapseThree">
                                            Can I rent badminton equipment at DreamSports?
                                        </a>
                                    </h2>
                                    <div id="collapseThree" class="accordion-collapse collapse"
                                        aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                                        <div class="accordion-body">
                                            <div class="accordion-content">
                                                <p>Book your DreamSports badminton court online or contact our customer
                                                    service for seamless reservations.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- /FAQ Item -->

                                <!-- FAQ Item -->
                                <div class="accordion-item">
                                    <h2 class="accordion-header" id="headingFour">
                                        <a href="javascript:;" class="accordion-button collapsed" data-bs-toggle="collapse"
                                            data-bs-target="#collapseFour" aria-expanded="false"
                                            aria-controls="collapseFour">
                                            Are there any coaching services available at DreamSports?
                                        </a>
                                    </h2>
                                    <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour"
                                        data-bs-parent="#accordionExample">
                                        <div class="accordion-body">
                                            <div class="accordion-content">
                                                <p>Book your DreamSports badminton court online or contact our customer
                                                    service for seamless reservations.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- /FAQ Item -->

                                <!-- FAQ Item -->
                                <div class="accordion-item">
                                    <h2 class="accordion-header" id="headingFive">
                                        <a href="javascript:;" class="accordion-button collapsed" data-bs-toggle="collapse"
                                            data-bs-target="#collapseFive" aria-expanded="false"
                                            aria-controls="collapseFive">
                                            Can I join badminton leagues or tournaments at DreamSports?
                                        </a>
                                    </h2>
                                    <div id="collapseFive" class="accordion-collapse collapse" aria-labelledby="headingFive"
                                        data-bs-parent="#accordionExample">
                                        <div class="accordion-body">
                                            <div class="accordion-content">
                                                <p>Book your DreamSports badminton court online or contact our customer
                                                    service for seamless reservations.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- /FAQ Item -->

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- /Best Services -->

    <!-- Courts Near -->
    <section class="section court-near">
        <div class="container">
            <div class="section-heading aos" data-aos="fade-up">
                <h2>Find Courts <span>Near You</span></h2>
                <p class="sub-title">Discover nearby badminton courts for convenient and accessible gameplay.</p>
            </div>
            <div class="row">
                <div class="featured-slider-group aos" data-aos="fade-up">
                    <div class="owl-carousel featured-venues-slider owl-theme">

                        <!-- Courts Item -->
                        <Carousel :wrap-around="true" :settings="settings" :breakpoints="breakpoints">
                            <Slide v-for="item in Near" :key="item.id">
                                <div class="featured-venues-item court-near-item">
                                    <div class="listing-item mb-0">
                                        <div class="listing-img">
                                            <router-link to="/coaches/venue-details">
                                                <img :src="require(`@/assets/img/venues/${item.Image}`)" alt="Venue">
                                            </router-link>
                                            <div class="fav-item-venues">
                                                <div class="list-reviews coche-star">
                                                    <a href="javascript:void(0)" class="fav-icon" @click="toggleSelected(item)"
                                                        :class="{ selected: item.isSelected }">
                                                        <i class="feather-heart"></i>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="listing-content text-start">
                                            <h3 class="listing-title">
                                                <router-link to="/coaches/venue-details">{{item.Title}}</router-link>
                                            </h3>
                                            <div class="listing-details-group">
                                                <ul>
                                                    <li>
                                                        <span>
                                                            <i class="feather-map-pin"></i>{{item.Address}}
                                                        </span>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="list-reviews near-review">
                                                <div class="d-flex align-items-center">
                                                    <span class="rating-bg">4.2</span><span>{{item.Reviews}}</span>
                                                </div>
                                                <span class="mile-away"><i class="feather-zap"></i>{{item.Distance}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Slide>
                            <template #addons>
                                <Navigation />
                            </template>
                        </Carousel>
                        <!-- /Courts Item -->

                    </div>
                </div>
            </div>

            <!-- View More -->
            <div class="view-all text-center aos" data-aos="fade-up">
                <router-link to="/coaches/listing-grid" class="btn btn-secondary d-inline-flex align-items-center">View All Services
                    <span class="lh-1"><i class="feather-arrow-right-circle ms-2"></i></span></router-link>
            </div>
            <!-- View More -->

        </div>
    </section>
    <!-- /Courts Near -->
</template>

<script>
import { Carousel, Navigation, Pagination, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import Near from '@/assets/json/home-near.json'
export default {
    data() {
        return {
            Near: Near,
            isSelected: false,
            settings: {
                itemsToShow: 1,
                snapAlign: "center",
            },
            breakpoints: {
                575: {
                    itemsToShow: 2,
                    snapAlign: "center",
                },
                767: {
                    itemsToShow: 2,
                    snapAlign: "center",
                },
                991: {
                    itemsToShow: 2,
                    snapAlign: "center",
                },
                1024: {
                    itemsToShow: 3,
                    snapAlign: "start",
                },
            },
        }
    },
    components: {
        Carousel,
        Slide,
        Navigation,
        Pagination
    },
    methods: {
        toggleSelected(item) {
            item.isSelected = !item.isSelected;
        },
    },
}
</script>